import { dataTrimLeft } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrimLeft = /*#__PURE__*/createIcon(dataTrimLeft)
export default IconTrimLeft
